import {useAccountStore} from "@/stores/AccountStore.js";
import api from "@/api/medsenger_api.js";
import {emitter} from "@/infrastructure/event_bus.js";

// Initializes timezone synchronization. Sends offset on token set and when it changes.
export function setupTimezoneSync() {
    const accountStore = useAccountStore();
    let lastTimezoneOffset = new Date().getTimezoneOffset();

    const checkAndSendTimezone = (force = false) => {
        const current = new Date().getTimezoneOffset();
        if (force || current !== lastTimezoneOffset) {
            lastTimezoneOffset = current;
            if (accountStore.isAuthorized()) {
                api.account.setTimezoneOffset(current).catch((e) => console.warn('Failed to set timezone offset', e));
            }
        }
    };

    // On token set (initialization or login), send current offset
    emitter.on('newTokenIsSet', () => {
        checkAndSendTimezone(true);
    });

    // Detect potential timezone changes
    const onFocus = () => checkAndSendTimezone(false);
    const onVisibility = () => {
        if (document.visibilityState === 'visible') checkAndSendTimezone(false);
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);

    // Periodic check to catch DST or background changes
    const intervalId = setInterval(() => checkAndSendTimezone(false), 60 * 1000);

    // Return a disposer in case we need to tear down listeners
    return () => {
        window.removeEventListener('focus', onFocus);
        document.removeEventListener('visibilitychange', onVisibility);
        clearInterval(intervalId);
    };
}

// Reads api_token and an optional role from the current URL.
export async function consumeApiToken() {
    try {
        const url = new URL(window.location.href);
        const tokenFromQuery = url.searchParams.get('api_token');
        const roleFromQuery = url.searchParams.get('role');
        if (tokenFromQuery) {
            const accountStore = useAccountStore();
            await accountStore.forceToken(tokenFromQuery)
            if (['doctor', 'patient'].includes(roleFromQuery)) {
                accountStore.setRole(roleFromQuery)
            }
        }
    } catch (e) {
        console.warn('Failed to process api_token from URL', e);
    }
}

// Removes sensitive bootstrap parameters from the URL after processing.
export function removeApiTokenFromUrl() {
    try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('api_token')) {
            url.searchParams.delete('api_token');
            url.searchParams.delete('role');
            const cleanedSearch = url.searchParams.toString();
            const cleanedPath = url.pathname + (cleanedSearch ? `?${cleanedSearch}` : '') + url.hash;
            window.history.replaceState({}, document.title, cleanedPath);
            console.log('api_token removed from URL (before router init)')
        }
    } catch (e) {
        console.warn('Failed to remove api_token from URL', e);
    }
}
